import * as React from "react";
import "./pipeline.scss";
import CRMSSO from "./pipeline";
import { pipelineobj } from "../../Entity/SSOObj";

export interface ISSOProps {
  Piplelines: pipelineobj[];
  Probability;
  Phases;
  UpdateMethod;
  LogTitle;
  InsideCRM;
  CRMURL;
  Phrases;
  ssocontacts;
  fotcontactrecent?;
  RefreshCRMData;
}
export default class PipelineList extends React.Component<ISSOProps, {}> {
  public constructor(props) {
    super(props);
  }
  public render() {
    return (
      <div className="pipeline">
        {this.props.Piplelines.map((SSOIem, index) => {
          let links='';
          if(SSOIem.ContactId && SSOIem.ContactId!='' && this.props.ssocontacts){
          links = this.props.ssocontacts[SSOIem.ContactId]
            ? this.props.ssocontacts[SSOIem.ContactId]
            : "";
          }
          let keyval=this.props.fotcontactrecent?"crmssorecent"+SSOIem.ID:"crmsso"+SSOIem.ID;
          let thumbclass=this.props.fotcontactrecent?"ssothumbitem":'';
          return (
            <div className={thumbclass}  key={keyval}>
              <CRMSSO
                data={SSOIem}
                key={SSOIem.ID}
                Probability={this.props.Probability}
                Phases={this.props.Phases}
                UpdateMethod={this.props.UpdateMethod}
                LogTitle={this.props.LogTitle}
                InsideCRM={this.props.InsideCRM}
                CRMURL={this.props.CRMURL}
                Phrases={this.props.Phrases}
                contactlinks={links}
                RefreshCRMData={this.props.RefreshCRMData}
              />
            </div>
            
          );
        })}
      </div>
    );
  }
}
